import type {
  UniversalSearchRequestBody,
  UniversalSearchListResponse,
  UniversalSearchHeaderResponse,
  UniversalSearchHeaderRequestBody,
  UniversalSearchCountResponse,
  UniversalMapResponse,
} from '@weberus/shared-types';

import { fetcher } from '@/app/_shared/utils/fetcher';

// ==================== 통합SRP ==================== //
/** 통합 SRP [V1] 헤더 영역 조회 */
export const fetchUniversalSearchHeader = async (args: UniversalSearchHeaderRequestBody, headers?: Headers) => {
  return fetcher<UniversalSearchHeaderResponse, UniversalSearchHeaderRequestBody>({
    method: 'POST',
    url: '/list/universal-search/v1/header',
    data: args,
    headers, // SSR 시에는 headers를 주입해야함
  });
};

/** 통합 SRP [V1] 리스트 조회 */
export const fetchUniversalSearch = async (args: UniversalSearchRequestBody, headers?: Headers) => {
  return fetcher<UniversalSearchListResponse, UniversalSearchRequestBody>({
    method: 'POST',
    url: '/list/universal-search/v1/list',
    data: args,
    headers, // SSR 시에는 headers를 주입해야함
  });
};

/* 통합 SRP [V1] CTA 버튼 개수 조회 */
export const fetchUniversalSearchCount = async (args: Omit<UniversalSearchRequestBody, 'sort' | 'page'>) => {
  return fetcher<UniversalSearchCountResponse, Omit<UniversalSearchRequestBody, 'sort' | 'page'>>({
    method: 'POST',
    url: '/list/universal-search/v1/count',
    data: args,
  });
};

/* 통합 SRP [V1] 지도 조회  */
export const fetchUniversalSearchMap = async (args: UniversalSearchRequestBody) => {
  return fetcher<UniversalMapResponse, UniversalSearchRequestBody>({
    method: 'POST',
    url: '/list/universal-search/v1/map-view',
    data: args,
  });
};

// ==================== 해외숙소 ==================== //
/** 해외숙소 통합 SRP [V1] 리스트 조회 */
export const fetchGlobalListUniversalSearch = async (args: UniversalSearchRequestBody, headers?: Headers) => {
  return fetcher<UniversalSearchListResponse, UniversalSearchRequestBody>({
    method: 'POST',
    url: '/global-list/universal-search/v1/list',
    data: args,
    headers,
  });
};
/** 해외숙소 통합 SRP [V1] 지도 조회 */
export const fetchGlobalListUniversalSearchMap = async (args: UniversalSearchRequestBody) => {
  return fetcher<UniversalMapResponse, UniversalSearchRequestBody>({
    method: 'POST',
    url: '/global-list/universal-search/v1/map-view',
    data: args,
  });
};
